import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { CssBaseline, notificationTemplateFactory } from 'common/components';
import { BannersCarousel } from 'features/banners-carousel';
import { BannersCarouselWidgetProps } from './types';
import { useClientBreakpoint } from '../../../../common/hooks/use-client-breakpoint';
import { NotificationList } from '@navi-toolbox/ui-components';

export const BannersCarouselWidget: React.FC<BannersCarouselWidgetProps> = ({ ...props }) => {
  const isMobileDevice = useClientBreakpoint(bp => bp.atMobile);

  return (
    <React.Suspense>
      <ThemeProvider>
        <CssBaseline />
        <BannersCarousel {...props} />
        <NotificationList isDesktop={!isMobileDevice} templateFactory={notificationTemplateFactory} />
      </ThemeProvider>
    </React.Suspense>
  );
};
